// "Staging" enabled environment

export const environment = {
    staging: true,
    production: true,
    hmr: false,
    appConfig: 'appconfig.Development.json',
    clientID: 'f444df42-cab6-4f74-97a0-5a81931ae3b3',
    Scopes: 'openid offline_access user.read Calendars.Read Calendars.ReadWrite Tasks.ReadWrite profile Presence.Read Presence.Read.All Presence.ReadWrite Files.ReadWrite.All People.Read Chat.Read Chat.ReadWrite Notes.Read.All Sites.Manage.All Contacts.ReadWrite',
    appUrl: 'http://localhost:22742'
};
